import {reactive} from 'vue'

// Deliberately a module of its own: everything inside <script setup> runs per
// component instance, and the server-side rate limit outlives a single mount of
// the keys screen. Navigating away and back must not re-enable a locked door.
// Values are epoch milliseconds; 0 means "not locked".
export const lockedUntil = reactive({front_door: 0, apartment_door: 0})
